import {
  stopRenderer,
  convertCMtoMeters,
  getJourneyPallets,
  warningRenderer,
  dateFormatter,
  getShipmentInfoFromStops,
  renderShipperOrderShippers,
} from '../utils';

const FR_template = (journey, offerLink) => {
  const {
    item_height,
    stops,
    extras,
    shipper_orders,
    id,
    net_full_cost,
    total_weight,
    start_time_from,
    end_time_to,
  } = journey;

  const country = 'FR';
  const maxHeight = convertCMtoMeters(item_height);
  const stopsToRender = stopRenderer(stops, country).join('');
  const stopsInfo = getShipmentInfoFromStops(stops, country);
  const payload = getJourneyPallets(journey, country);
  const warning = warningRenderer(extras, country);
  const when = dateFormatter(start_time_from, end_time_to, country);
  const deepLink = `${offerLink}${id}`;
  const shippers = renderShipperOrderShippers(shipper_orders);

  return `
NEW JOB:

WHEN: ${when}

COMPANY: ${shippers}

We pay you: ${net_full_cost}€ + VAT
Total weight: ${total_weight} Kg
Payload: ${payload}
Max. pallet height: ${maxHeight}m

${stopsInfo.PICKUP} Pickup(s), ${stopsInfo.DROPOFF} Dropoff(s)
${stopsToRender}
${warning}

If you have the app installed click here to accept the job:
${deepLink}


Or reply with the following information:
- The reference number(Reference Number: ${id})
- The registration number of the vehicle that will be used for the job and the name of the driver
  `;
};

export default FR_template;
